import { transformConstants } from '../helpers/transformConstants';

const billingEventConstants = transformConstants([
  'MOKAPOS_SETTING_BILLING_PAY',
  'MOKAPOS_RENEWAL_FULL_FLOW',
  'MOKAPOS_RENEWAL_BANNER_CLICK',
  'MOKAPOS_RENEWAL_BILLING_PAY',
  'MOKAPOS_TURN_ON_SUBSCRIPTION_OUTLET',
  'MOKAPOS_TURN_OFF_SUBSCRIPTION_OUTLET',
  'MOKAPOS_SETTING_BILLING_START',
  'MOKAPOS_BILLING_PAYMENT_REDIRECT_TO_MIDTRANS',
  'MOKAPOS_SETTING_BILLING_PAYMENT_SUCCESSFUL',
  'MOKAPOS_SETTING_BILLING_PAYMENT_FAILED',
]);

export { billingEventConstants };
